import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      // Conserve la vue consultée lors du changement de finition.
      const previousIndex = currentMediaGallery.slider?.index || 0;
      const mediaCount = newMediaGallery.querySelectorAll('.product-media-gallery-main-slider .product-media-gallery__media').length;
      currentMediaGallery.replaceWith(newMediaGallery);
      if (newMediaGallery.slider && mediaCount > 0) {
        newMediaGallery.slider.go(Math.min(previousIndex, mediaCount - 1));
      }
      const currentZoom = this.querySelector('product-zoom');
      const newZoom = event.detail.data.html.querySelector('product-media-gallery product-zoom');
      if (currentZoom || newZoom) {
        if (currentZoom && newZoom) currentZoom.replaceWith(newZoom);
        else if (currentZoom) currentZoom.remove();
        else if (newZoom) this.append(newZoom);
      }


      // Réactive les boutons AR (data-shopify-xr) présents dans le nouveau HTML
      window.ShopifyXR?.setupXRElements();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
